<template>
    <div id="features" class="offset">
        <div class="jumbotron">
            <div class="narrow text-center">
                <div class="col-md-12 text-center">
                    <h3 class="heading">Szolgátatásaink</h3>
                    <div class="heading-underline"></div>
                </div>
                <div class="row text-center">
                    <div class="col-md-4">
                        <div class="feature">
                            <i
                                class="fas fas fa-star fa-4x"
                                data-fa-transform="shrink-4.5 up-4.5"
                            ></i>
                            <!-- TODO: Add jpg picture with the correct size -->
                            <!-- <i class="col-md-4">
                            <img src="../assets/images/service1.jpg" />
                            </i> -->
                            <h3>Fogmegtartó kezelések</h3>
                            <p>
                                Fogmegtartó kezeléseink során a fájdalom megszüntetetésén túl mindent elkövetünk, hogy fogait még hosszú évekig gond nélkül tudja használni.
                            </p>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="feature">
                            <i
                                class="fas fa-smile fa-4x"
                                data-fa-transform="shrink-4.5 up-4.5"
                            ></i>
                            <!-- fontawesome: https://www.angularjswiki.com/fontawesome/ -->
                            <h3>Fogpótlások</h3>
                            <p>
                            A fogpótlásokkal - legyen az akár híd, korona, kivehető fogsor vagy implantátum-, visszaadjuk önbizalmát és nem utolsó sorban rágóképességét
                            </p>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="feature">
                            <i
                                class="fas fa-syringe fa-4x"
                                data-fa-transform="shrink-4 up-5"
                            ></i>
                            <h3>Esztétikai beavatkozás</h3>
                            <p>
                            Nem csak ép, de gyökérkezelt fogak fehérítését is elvégezzük, illetve orvosi hozzáértéssel helyezzük fel a páciens által választott fogékszereket is.                            
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "features"
};
</script>
<style scoped>
#features .narrow{
    padding-top: 0;
}
#features:before {
    display: block;
    content: "";
    height: 3.7rem;
    margin-top: -3.7rem;
}
.feature h3 {
    font-size: 1.3rem;
    text-transform: uppercase;
    padding-bottom: 0.4rem;
}
.feature p {
    font-size: 1.1rem;
}
</style>
